import { createContext } from 'react';
import { distinctNames } from '../../GeoTargeter/constants';
import { DistinctNamesValues, GeoItem } from '../../GeoTargeter/types';

export const plainItems = [
  distinctNames.countries,
  distinctNames.empty,
  distinctNames.country,
] as DistinctNamesValues[];

export const GeographyContext = createContext<{ countries: GeoItem[] }>({
  countries: [],
});
